const cardItems = [
  {
    id: 1,
    title: '《斗罗大陆》',
    tag: '国漫·玄幻',
    desc: '唐三穿越斗罗大陆，觉醒双生武魂昊天锤与蓝银草，一步步踏上封号斗罗之路。',
    src: 'https://readdy.ai/api/search-image?query=A%20young%20warrior%20in%20blue%20and%20gold%20armor%20with%20martial%20arts%20pose%2C%20surrounded%20by%20spiritual%20energy%20and%20a%20giant%20hammer%20weapon%2C%20Chinese%20fantasy%20illustration%2C%20warm%20orange%20atmosphere%2C%20clean%20light%20background&width=600&height=800&seq=card-comic-01&orientation=portrait',
    readers: '892万',
    status: '连载中',
  },
  {
    id: 2,
    title: '《海贼王》',
    tag: '日漫·冒险',
    desc: '路飞率领草帽海贼团航行伟大航路，寻找传说中的 ONE PIECE 大秘宝。',
    src: 'https://readdy.ai/api/search-image?query=A%20young%20pirate%20captain%20in%20a%20straw%20hat%20with%20a%20bright%20smile%2C%20standing%20on%20a%20ship%20with%20ocean%20waves%2C%20adventure%20manga%20style%2C%20warm%20golden%20sunlight%2C%20clean%20illustration&width=600&height=800&seq=card-comic-02&orientation=portrait',
    readers: '1,256万',
    status: '连载中',
  },
  {
    id: 3,
    title: '《我独自升级》',
    tag: '韩漫·战斗',
    desc: '最低级猎人程肖宇在生死边缘觉醒系统面板，从最弱一步步升级为暗影君主。',
    src: 'https://readdy.ai/api/search-image?query=A%20dark%20haired%20young%20man%20with%20glowing%20purple%20eyes%20and%20shadow%20army%20behind%20him%2C%20Korean%20manhwa%20style%2C%20dramatic%20lighting%2C%20dark%20atmosphere%20with%20warm%20accents&width=600&height=800&seq=card-comic-03&orientation=portrait',
    readers: '678万',
    status: '已完结',
  },
  {
    id: 4,
    title: '《凡人修仙传》',
    tag: '国漫·修仙',
    desc: '平凡山村少年韩立偶然踏入修仙之路，凭借智慧和谨慎在残酷修真界生存。',
    src: 'https://readdy.ai/api/search-image?query=A%20cultivator%20in%20flowing%20white%20and%20green%20robes%20meditating%20on%20a%20mountain%20peak%2C%20surrounded%20by%20floating%20swords%20and%20mist%2C%20Chinese%20xianxia%20illustration%2C%20warm%20ethereal%20light&width=600&height=800&seq=card-comic-04&orientation=portrait',
    readers: '543万',
    status: '连载中',
  },
  {
    id: 5,
    title: '《鬼灭之刃》',
    tag: '日漫·热血',
    desc: '炭治郎为救妹妹祢豆子踏上斩鬼之旅，水之呼吸斩尽世间恶鬼。',
    src: 'https://readdy.ai/api/search-image?query=A%20young%20swordsman%20with%20green%20checkered%20haori%20holding%20a%20katana%2C%20water%20dragon%20effect%20surrounding%20him%2C%20Japanese%20manga%20style%2C%20dynamic%20action%20pose%2C%20warm%20sunset%20colors&width=600&height=800&seq=card-comic-05&orientation=portrait',
    readers: '987万',
    status: '已完结',
  },
  {
    id: 6,
    title: '《完美世界》',
    tag: '国漫·玄幻',
    desc: '石昊自大荒走出，以无敌之姿横推各路天骄，证道完美至尊之位。',
    src: 'https://readdy.ai/api/search-image?query=A%20young%20warrior%20with%20golden%20glowing%20body%20in%20ancient%20Chinese%20setting%2C%20standing%20on%20a%20battlefield%20with%20epic%20energy%20waves%2C%20fantasy%20illustration%2C%20warm%20amber%20and%20gold%20tones&width=600&height=800&seq=card-comic-06&orientation=portrait',
    readers: '765万',
    status: '连载中',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-3 mb-10 md:mb-14">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">热门推荐</h2>
            <p className="text-foreground-500 text-sm">精选全网最热漫画，每日更新追更必看</p>
          </div>
          <span className="text-sm text-primary-500 font-medium cursor-pointer hover:text-primary-600 transition-colors whitespace-nowrap flex items-center gap-1">
            查看全部 <i className="ri-arrow-right-line"></i>
          </span>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {cardItems.map((item) => (
            <div
              key={item.id}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden bg-background-100 mb-3">
                <img
                  src={item.src}
                  alt={`${item.title} - ${item.tag} 免费漫画在线看`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 bg-primary-500/90 text-background-50 text-[10px] font-medium rounded">
                    {item.status}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent p-3">
                  <span className="text-background-50 text-[10px] font-medium bg-black/40 px-2 py-0.5 rounded">
                    {item.tag}
                  </span>
                </div>
              </div>
              <h3 className="font-heading text-sm text-foreground-950 mb-1 group-hover:text-primary-500 transition-colors line-clamp-1">
                {item.title}
              </h3>
              <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2 mb-1.5">{item.desc}</p>
              <span className="text-foreground-400 text-[11px]">{item.readers} 人看过</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}